import { useToastStore } from '../../stores/toastStore';

const variantStyles = {
  default: 'border-l-4 border-l-brand-500 bg-card',
  success: 'border-l-4 border-l-green-500 bg-card',
  error: 'border-l-4 border-l-red-500 bg-card',
} as const;

export function Toaster() {
  const toastData = useToastStore((s) => s.toast);
  const dismiss = useToastStore((s) => s.dismiss);

  if (!toastData) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 z-[100] animate-in slide-in-from-bottom-4 fade-in duration-200">
      <div
        role="alert"
        className={`rounded-lg shadow-lg p-3 ${variantStyles[toastData.variant]}`}
        onClick={dismiss}
      >
        <p className="text-sm font-medium text-foreground">{toastData.title}</p>
        {toastData.description && (
          <p className="text-xs text-muted-foreground mt-0.5">{toastData.description}</p>
        )}
      </div>
    </div>
  );
}
